var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useCallback, useEffect } from 'react';
import submitAIAdLandingForm from '../services/aiAdLandingService';
const useLandingPageForm = ({ user }) => {
    const [formState, setFormState] = useState({
        data: {
            name: (user === null || user === void 0 ? void 0 : user.name) || '',
            email: (user === null || user === void 0 ? void 0 : user.email) || ''
        },
        isSubmitting: false,
        isSubmitted: false,
        error: null,
        success: false
    });
    useEffect(() => {
        if (user && !formState.isSubmitted) {
            setFormState((prev) => (Object.assign(Object.assign({}, prev), { data: {
                    name: user.name || prev.data.name,
                    email: user.email || prev.data.email
                } })));
        }
    }, [user, formState.isSubmitted]);
    const updateField = useCallback((field, value) => {
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { data: Object.assign(Object.assign({}, prev.data), { [field]: value }), error: null })));
    }, []);
    const submitForm = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { isSubmitting: true, error: null })));
        try {
            yield submitAIAdLandingForm(formState.data);
            setFormState((prev) => (Object.assign(Object.assign({}, prev), { isSubmitting: false, isSubmitted: true, success: true, error: null })));
        }
        catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'An error occurred while submitting the form';
            setFormState((prev) => (Object.assign(Object.assign({}, prev), { isSubmitting: false, error: errorMessage, success: false })));
        }
    }), [formState.data]);
    const resetForm = useCallback(() => {
        setFormState({
            data: {
                name: (user === null || user === void 0 ? void 0 : user.name) || '',
                email: (user === null || user === void 0 ? void 0 : user.email) || ''
            },
            isSubmitting: false,
            isSubmitted: false,
            error: null,
            success: false
        });
    }, [user]);
    return {
        formState,
        updateField,
        submitForm,
        resetForm
    };
};
export default useLandingPageForm;
